import React from 'react';
import { useHistory } from 'react-router-dom';
import styles from './index.module.scss';

import { CustomTableAddButton } from 'components/Tables/CustomTable';
import { ReactComponent as AddIcon } from 'assets/img/icons/add.svg';

export default function CreateExceptionButton({
  routeTo = '',
  disabled = false,
  onClick = () => {},
  children = null
}) {
  const { push } = useHistory();

  const onButtonClick = () => {
    if (disabled) return;
    routeTo ? push(routeTo) : onClick();
  };

  return (
    <CustomTableAddButton
      disabled={disabled}
      onClick={onButtonClick}
      customClass={styles.button}
    >
      <div className={styles.content}>
        <AddIcon className={styles.icon} />
        {children || 'Add Exeption'}
      </div>
    </CustomTableAddButton>
  );
}
